import Phaser from 'phaser'
import { GameOptions, GameConsts } from './gameOptions';
import DisplayHelper from './displayHelper';

import { ResourcesService, Resources } from '../services/resources.service'
import TextureKeys from './textureKeys';
import { ModernPlayButton } from './modernPlayButton';


export default class GameOver extends Phaser.Scene
{
    private isFirstGame = false;
    private picDownloaded = false;
    private openGammataPortal = true;
    private width;
    private height;
    private screenshotX;
    private screenshotY;
    private homeX;
    private homeY;

    constructor(private resourcesService: ResourcesService)
    {
        super('GameOver')
    }

    create()
    {
        this.width = this.scale.width;
        this.height = this.scale.height;

        this.screenshotX = this.width - 300;
        this.screenshotY = this.height - 320;

        console.log('in gameover create');
        this.scene.pause('PlayGame');

        const getGameEndTextW = this.width * 0.5;
        const getGameEndTextH = this.height * 0.5 - 150;

        // Create decorative frame for game over text
        const gameOverPanel = this.add.graphics();
        gameOverPanel.setDepth(0);
        
        // Create gradient background
        gameOverPanel.fillGradientStyle(0x1a1a1a, 0x1a1a1a, 0x2d2d2d, 0x2d2d2d, 0.95);
        gameOverPanel.fillRoundedRect(
            getGameEndTextW - (this.width - 100) / 2 - 10,
            getGameEndTextH - 50,
            this.width - 80,
            120,
            15
        );
        
        // Add border with red/orange color for game over
        gameOverPanel.lineStyle(3, 0xFF6347, 1); // Tomato red color
        gameOverPanel.strokeRoundedRect(
            getGameEndTextW - (this.width - 100) / 2 - 10,
            getGameEndTextH - 50,
            this.width - 80,
            120,
            15
        );
        
        // Add inner glow
        gameOverPanel.lineStyle(1.5, 0xFFFFFF, 0.25);
        gameOverPanel.strokeRoundedRect(
            getGameEndTextW - (this.width - 100) / 2 - 7,
            getGameEndTextH - 47,
            this.width - 86,
            114,
            13
        );
        
        // Entrance animation for panel
        gameOverPanel.setScale(0);
        this.tweens.add({
            targets: gameOverPanel,
            scale: 1,
            duration: 500,
            ease: 'Back.out'
        });
        
        // Pulsing glow animation
        this.tweens.add({
            targets: gameOverPanel,
            alpha: 0.85,
            duration: 1500,
            ease: 'Sine.inOut',
            yoyo: true,
            repeat: -1,
            delay: 600
        });

        const gameOverText = this.add.text(getGameEndTextW, getGameEndTextH, this.resourcesService.getGameEndText(), {
            fontFamily: 'Luckiest Guy',
            fontSize: '56px',
            color: GameConsts.yellowColor,
            fontStyle: 'normal',
            // stroke: '#FFFFFF',
            stroke: GameConsts.blackColor,
            strokeThickness: 4,
            shadow: { offsetY: 1, offsetX: 1, blur: 2, fill: true, color: GameConsts.blackColor, stroke: true },
            wordWrap: { width: this.width - 100 },
            align: 'center'
        })
        .setOrigin(0.5)
        .setDepth(1);
        
        // Animate text entrance
        gameOverText.setScale(0);
        this.tweens.add({
            targets: gameOverText,
            scale: 1,
            duration: 400,
            ease: 'Back.out',
            delay: 200
        });
        
        // Add subtle floating animation
        this.tweens.add({
            targets: [gameOverPanel, gameOverText],
            y: '+=5',
            duration: 3000,
            ease: 'Sine.inOut',
            yoyo: true,
            repeat: -1,
            delay: 800
        });

        this.homeX = 50
        this.homeY = this.height - 100;

        // Create modern play button for restart
        const restartButton = new ModernPlayButton(this, this.width * 0.5, this.height * 0.5);
        
        // Handle restart click
        restartButton.on('pointerdown', () => {
            this.isFirstGame = false;
            this.scene.stop('GameOver');
            
            // stop and restart the Game scene
            this.scene.stop('PlayGame');
            this.scene.start('PlayGame');
        });

        const textX = this.homeX + 160;
        const textY = this.homeY - 150;

        // Background rectangle for the text
        const textBg = this.add.graphics();
        textBg.fillStyle(0x333333, 0.8); // Dark gray background
        textBg.fillRoundedRect(textX - 150, textY - 20, 300, 40, 8);
        textBg.lineStyle(2, 0xFFD700, 1); // Yellow border
        textBg.strokeRoundedRect(textX - 150, textY - 20, 300, 40, 8);

        // Clickable text with yellow color and larger font
        const clickableText = this.add.text(textX, textY, "Click To Build Your Dream Game", {
            fontFamily: 'Arial',
            fontSize: '20px',
            color: '#FFD700',
            fontStyle: 'normal'
        })
        .setOrigin(0.5, 0.5)
        .setInteractive({ useHandCursor: true })
        .on('pointerover', () => {
            // Hover effect
            clickableText.setColor('#FFFFFF');
            textBg.clear();
            textBg.fillStyle(0x555555, 0.9);
            textBg.fillRoundedRect(textX - 150, textY - 20, 300, 40, 8);
            textBg.lineStyle(2, 0xFFFFFF, 1);
            textBg.strokeRoundedRect(textX - 150, textY - 20, 300, 40, 8);
        })
        .on('pointerout', () => {
            // Reset hover effect
            clickableText.setColor('#FFD700');
            textBg.clear();
            textBg.fillStyle(0x333333, 0.8);
            textBg.fillRoundedRect(textX - 150, textY - 20, 300, 40, 8);
            textBg.lineStyle(2, 0xFFD700, 1);
            textBg.strokeRoundedRect(textX - 150, textY - 20, 300, 40, 8);
        })
        .on('pointerdown', () => {
            // Open in new tab
            window.open('https://setup.gammata.net', '_blank');
        });
    
        // this.add.image(
        //     this.homeX,
        //     this.homeY -50,
        //     TextureKeys.DownloadButton
        // ).setScale(0.08)
        // .setOrigin(0.5, 0.5);

        // const loadButtonTextW = this.homeX + 30;
        // const loadButtonTextH = this.homeY - 50;

        // this.add.text(loadButtonTextW, loadButtonTextH, "Click download your game's snapshot", {
        //     fontFamily: 'Luckiest Guy',
		// 	fontSize: '18px',
		// 	color: GameConsts.blueColor,
		// 	fontStyle: 'normal',
		// 	stroke: '#FFFFFF',
		// 	strokeThickness: 9,
        // })
        // .setOrigin(0, 0.5);

        const raceButtonText1W = this.width/2 + 150;
        const raceButtonText1H = this.height/2 - 15;

        var raceButtonText1 = this.add.text(raceButtonText1W, raceButtonText1H, 'Race', {
            fontSize: '40px',
            color: GameConsts.blackColor,
            fontStyle: 'normal',
            stroke: GameConsts.blackColor,
            strokeThickness: 1,
            shadow: { offsetY: 1, offsetX: 1, blur: 2, fill: true, color: GameConsts.blackColor, stroke: true }
        })
        .setOrigin(0.5, 0.5)
        .setDepth(10);

        const raceButtonText2W = this.width/2 + 150;
        const raceButtonText2H = this.height/2 + 15;

        var raceButtonText2 = this.add.text(raceButtonText2W, raceButtonText2H, 'mode', {
            fontSize: '40px',
            color: GameConsts.blackColor,
            fontStyle: 'normal',
            stroke: GameConsts.blackColor,
            strokeThickness: 1,
            shadow: { offsetY: 1, offsetX: 1, blur: 2, fill: true, color: GameConsts.blackColor, stroke: true }
        })
        .setOrigin(0.5, 0.5)
        .setDepth(10);

        const raceButtonW = this.width/2 + 150;
        const raceButtonH = this.height/2;

        const raceButton = this.add.sprite(raceButtonW, raceButtonH, TextureKeys.RaceModeButton)
        .setInteractive()
        .setOrigin(0.5, 0.5)
        .setScale(0.16)
        .on('pointerdown', () => {
            if (this.resourcesService.getGameMode() == 'RaceMode') { 
                DisplayHelper.toggleButtonColor(0xffff, 'black', 'black', raceButton, raceButtonText1, raceButtonText2);
                this.resourcesService.setGameMode('RegularMode');
            } else {
                DisplayHelper.toggleButtonColor(0xFF0000, 'white', 'white', raceButton, raceButtonText1, raceButtonText2);
                this.resourcesService.setGameMode('RaceMode');
            }
        });

        if (this.resourcesService.getGameMode() == 'RaceMode') { 
            DisplayHelper.toggleButtonColor(0xFF0000, 'white', 'white', raceButton, raceButtonText1, raceButtonText2);
        } else {
            DisplayHelper.toggleButtonColor(0xffff, 'black', 'black', raceButton, raceButtonText1, raceButtonText2);
        }
    }

    update () {

        if (this.input.activePointer.isDown)
        {
            if (Phaser.Math.Difference(this.input.activePointer.downX, this.homeX ) < 50 && Phaser.Math.Difference(this.input.activePointer.downY, this.homeY - 50) < 50 &&  !this.picDownloaded)
            {
                const link = document.createElement('a');
                link.download = 'download.png';
                link.href = this.resourcesService.getSnapshot();
                link.click();
                this.picDownloaded = true;
            }    
        }


        this.checkIfToStart(this.screenshotX, this.screenshotY);
    }
   
    sleep (time) {
        return new Promise((resolve) => setTimeout(resolve, time));
    }
    
    
    checkIfToStart(screenshotX: number, screenshotY: number)
    {      
        // Button click is now handled by the ModernPlayButton itself
    }
}
